var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ob1-popin-modal-visual", {
    attrs: {
      id: _vm.modalId,
      "aria-labelledby": _vm.modalAriaLabel,
      "show-close-button": true,
      "additional-classes": "d-webview-none",
    },
    scopedSlots: _vm._u([
      {
        key: "visual",
        fn: function () {
          return [
            _c("div", { staticClass: "ob1-modal-img d-webview-none" }, [
              _c("div", { staticClass: "image-crop" }, [
                _c("img", {
                  attrs: { src: _vm.visual.src, alt: _vm.visual.alt },
                }),
              ]),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "content",
        fn: function () {
          return [
            _c("h4", { domProps: { innerHTML: _vm._s(_vm.title) } }),
            _vm._v(" "),
            _vm.displayPromo
              ? [
                  _vm.displayOdr
                    ? _c("span", { staticClass: "lead" }, [
                        _c("strong", {
                          domProps: { innerHTML: _vm._s(_vm.modalPromoTitle) },
                        }),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "standard",
                    domProps: { innerHTML: _vm._s(_vm.modalPromoText) },
                  }),
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.displayOdr
              ? [
                  _vm.displayPromo
                    ? [
                        _c("div", { staticClass: "py-1" }, [
                          _c("hr", {
                            staticClass: "separator separator--gray4",
                          }),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "lead" }, [
                          _c("strong", {
                            domProps: { innerHTML: _vm._s(_vm.modalOdrTitle) },
                          }),
                        ]),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "standard",
                    domProps: { innerHTML: _vm._s(_vm.modalOdrText) },
                  }),
                  _vm._v(" "),
                  _vm.odrLink
                    ? _c("ob1-liens", {
                        staticClass: "mb-1",
                        attrs: {
                          "with-arrow": "",
                          "is-mini": "",
                          text: _vm.odrLinkLabel,
                          href: _vm.odrLink,
                          target: "_blank",
                        },
                      })
                    : _vm._e(),
                ]
              : _vm._e(),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }